import { useState, useCallback } from 'react';
import { authHeaders } from '../utils/api';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useInvestigation(datasetIds) {
  const [showInvestigation, setShowInvestigation] = useState(false);
  const [investigationFilters, setInvestigationFilters] = useState(null);
  const [investigationData, setInvestigationData] = useState(null);
  const [investigationLoading, setInvestigationLoading] = useState(false);

  const applyInvestigationFilters = useCallback(async (filters) => {
    setShowInvestigation(false);
    if (!filters || !datasetIds) {
      setInvestigationFilters(null);
      setInvestigationData(null);
      return;
    }
    const hasFilters = filters.occupations || filters.employers || filters.committees ||
      filters.minAmount != null || filters.maxAmount != null ||
      filters.minYear != null || filters.maxYear != null ||
      filters.minYearsActive != null || filters.maxYearsActive != null ||
      (filters.patterns && filters.patterns.length > 0);
    const isHeatMode = filters.mode === 'heat_dollars' || filters.mode === 'heat_count';

    if (!hasFilters && !isHeatMode) {
      setInvestigationFilters(null);
      setInvestigationData(null);
      return;
    }

    setInvestigationFilters(filters);
    setInvestigationLoading(true);
    try {
      const res = await fetch(`${API}/map/investigation-data`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...authHeaders() },
        body: JSON.stringify({
          dataset_ids: datasetIds,
          occupations: filters.occupations,
          employers: filters.employers,
          committees: filters.committees,
          min_amount: filters.minAmount,
          max_amount: filters.maxAmount,
          min_year: filters.minYear,
          max_year: filters.maxYear,
          min_years_active: filters.minYearsActive,
          max_years_active: filters.maxYearsActive,
          patterns: filters.patterns,
          mode: filters.mode || 'pins',
        }),
      });
      const data = await res.json();
      setInvestigationData(data);
    } catch (e) {
      console.error('Investigation query failed:', e);
    } finally {
      setInvestigationLoading(false);
    }
  }, [datasetIds]);

  const clearInvestigation = () => {
    setInvestigationFilters(null);
    setInvestigationData(null);
  };

  const isActive = investigationFilters != null;
  const mode = investigationFilters?.mode || 'pins';

  return {
    showInvestigation,
    setShowInvestigation,
    investigationFilters,
    investigationData,
    investigationLoading,
    applyInvestigationFilters,
    clearInvestigation,
    isActive,
    mode,
  };
}
